import React from 'react';

const Label = ({
  children,
  ...props
}) => {
  return (
    <label className="label" {...props}>
      {children}
    </label>
  );
};

export default Label


// WEBPACK FOOTER //
// ./src/components/Label.js